import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TrendingUp } from 'lucide-react';
import { useFadeInOnScroll } from '../../../hooks/useFadeInOnScroll';
import { Container, PrimaryButton } from '../../styles/sharedComponents';
import { ZoomableImage } from './ZoomableImage';
import {
  HumanismSection,
  HumanismGrid,
  HumanismContent,
  HumanismTitle,
  HumanismDescription,
  NotebookContainer,
  NotebookFrame,
  NotebookScreen,
  DualImageContainer
} from './styles';

const Humanism: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [ref, isVisible] = useFadeInOnScroll<HTMLElement>();
  const [isNotebookHovered, setIsNotebookHovered] = useState(false);

  return (
    <HumanismSection ref={ref} $isVisible={isVisible}>
      <Container>
        <HumanismGrid>
          <HumanismContent>
            <HumanismTitle>
              {t('humanism.title')}
            </HumanismTitle>
            <HumanismDescription
              dangerouslySetInnerHTML={{ __html: t('humanism.description1') }}
            />
            <HumanismDescription
              dangerouslySetInnerHTML={{ __html: t('humanism.description2') }}
            />
            <PrimaryButton onClick={() => navigate('/philosophy')}>
              {t('humanism.cta')}
              <TrendingUp size={18} />
            </PrimaryButton>
          </HumanismContent>

          <NotebookContainer
            onMouseEnter={() => setIsNotebookHovered(true)}
            onMouseLeave={() => setIsNotebookHovered(false)}
          >
            <NotebookFrame style={{
              transform: isNotebookHovered ? 'rotateX(0deg) rotateY(0deg)' : 'rotateX(5deg) rotateY(-5deg)',
              transition: 'transform 0.5s ease'
            }}>
              <NotebookScreen>
                <DualImageContainer>
                  <ZoomableImage src="/icons/preview1.webp" />
                  <ZoomableImage src="/icons/preview2.webp" />
                </DualImageContainer>
              </NotebookScreen>
            </NotebookFrame>
          </NotebookContainer>
        </HumanismGrid>
      </Container>
    </HumanismSection>
  );
};

export default Humanism;
